import { schema } from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';

export const selectCountySchema = createSelectSchema(schema.counties);

export const insertCountySchema = createInsertSchema(schema.counties);
